import * as yup from "yup"
import { Grid2 as Grid, Button } from "@mui/material"
import { Formik } from "formik"
import { WithAllegatiImmagine } from "../../types"
import { useMemo } from "react"
import { transformErrorForForm } from "../../utils/utils"
import { FormInDialogEditProps } from "../DialogForm"
import { useTranslation } from "react-i18next"
import {AllegatiImmagineField } from "./allegatiHelpers"


export default function AllegatiImmagineForm({ item, save, ref }: FormInDialogEditProps<WithAllegatiImmagine>) {
  const { t } = useTranslation()

  const schema = useMemo(
    () =>
      yup.object().shape({
        allegati_immagine_data: yup.array().of(
          yup.object().shape({
            attachment: yup.mixed().required(t("allegati.file")),
          })
        ),
        
      }),
    [t]
  )

  return (
    <Formik
      validationSchema={schema}
      initialValues={item}
      enableReinitialize
      onSubmit={(values, formikBag) => {
        return save(values as WithAllegatiImmagine).catch((e) => {
          const localError = transformErrorForForm(e)
          formikBag.setErrors(localError)
        })
      }}
    >
      {({ handleSubmit, values }) => {
        return (
          <form onSubmit={handleSubmit} noValidate>
            <Grid container spacing={1}>
              <Grid size={12}>
              <AllegatiImmagineField name="allegati_immagine_data" values={{ ...values, allegati_immagine_data: values.allegati_immagine_data ?? [] }} />
              </Grid>
            </Grid>

            <Button ref={ref} type="submit" color="primary" sx={{ display: "none" }}></Button>
          </form>
        )
      }}
    </Formik>
  )
}
